var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcierge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.187,
    height: 71.484,
    viewBox: "0 0 65.187 71.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-concierge-3378388",
    transform: "translate(-3.388 -2.169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 1.793,
    cy: 1.793,
    r: 1.793,
    transform: "translate(27.038 57.336)",
    fill: "#04200f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1.796,
    cy: 1.796,
    r: 1.796,
    transform: "translate(27.035 64.427)",
    fill: "#04200f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 1.793,
    cy: 1.793,
    r: 1.793,
    transform: "translate(41.334 57.336)",
    fill: "#04200f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 1.796,
    cy: 1.796,
    r: 1.796,
    transform: "translate(41.331 64.427)",
    fill: "#04200f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36581",
    "data-name": "Trac\\xE9 36581",
    d: "M25.052,42.356c8.453,0,14.766-11,14.766-20.836a18.5,18.5,0,0,0-.923-5.884,1.178,1.178,0,0,0,.225-.336C41.092,10,37.673,5.187,37.529,4.986a1.287,1.287,0,0,0-.514-.419,25.771,25.771,0,0,0-11.962-2.4,25.8,25.8,0,0,0-11.962,2.4,1.27,1.27,0,0,0-.514.419c-.147.2-3.564,5.011-1.592,10.313a1.327,1.327,0,0,0,.225.333,18.436,18.436,0,0,0-.923,5.887C10.286,31.355,16.6,42.356,25.052,42.356ZM13.7,16.493a62.243,62.243,0,0,0,11.352.946c1.173,0,2.256-.031,3.285-.075-2.026.863-5.481,1.584-11.306.99a1.2,1.2,0,0,0-.646.1,8.6,8.6,0,0,0-3.512,3.029A15.819,15.819,0,0,1,13.7,16.493Zm22.7,0a15.29,15.29,0,0,1,.762,4.228A14.791,14.791,0,0,0,33.027,17C34.427,16.834,35.552,16.653,36.4,16.5ZM25.052,39.772c-5.267,0-9.719-6.083-11.427-12.683.375-3.956,2.383-5.551,3.5-6.13,7.535.716,11.688-.641,13.944-2.106,1.625.866,5.153,3.2,5.634,7.331C35.187,33.12,30.559,39.772,25.052,39.772ZM14.5,6.764a23.608,23.608,0,0,1,10.556-2.01,23.6,23.6,0,0,1,10.556,2.01A9.473,9.473,0,0,1,36.9,13.756a57.349,57.349,0,0,1-11.849,1.1,57.349,57.349,0,0,1-11.848-1.1A9.477,9.477,0,0,1,14.5,6.764Z",
    transform: "translate(10.927)",
    fill: "#04200f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36582",
    "data-name": "Trac\\xE9 36582",
    d: "M61.589,23.953,51.027,19.612l-2.9-3.083a1.3,1.3,0,0,0-1.7-.16,41.632,41.632,0,0,1-4.272,2.912,1.289,1.289,0,0,0-.894,1.23V23.6c0,.842-2.4,1.85-5.277,2.228C33.1,25.449,30.7,24.442,30.7,23.6V20.511a1.291,1.291,0,0,0-.894-1.23,41.629,41.629,0,0,1-4.272-2.912,1.293,1.293,0,0,0-1.7.16l-2.9,3.083L10.373,23.953c-7.021,2.892-7,6.515-6.982,10.014l0,16.291A1.293,1.293,0,0,0,4.685,51.55H67.279a1.293,1.293,0,0,0,1.292-1.292l0-16.291C68.589,30.468,68.61,26.845,61.589,23.953ZM43.84,23.6v-2.31c.628-.377,1.6-1.029,3.181-2.163l2.313,2.458a1.288,1.288,0,0,0,.45.31l1.687.7c-1.181,2.344-4.923,7.758-14.2,8.365V28.24C39.861,27.788,43.84,26.607,43.84,23.6ZM22.175,21.9a1.288,1.288,0,0,0,.45-.31l2.313-2.458c1.576,1.132,2.553,1.786,3.181,2.163V23.6c0,3.005,3.98,4.186,6.569,4.641v2.713c-9.285-.618-13.024-6.024-14.2-8.362ZM5.972,33.954c-.018-3.357-.028-5.383,5.383-7.613l6.734-2.765c1.364,2.788,5.727,9.3,16.6,9.959v15.43H5.974ZM65.984,48.966H37.271V33.538c10.869-.651,15.234-7.169,16.6-9.962L60.6,26.341c5.411,2.23,5.4,4.256,5.383,7.613Z",
    transform: "translate(0 22.103)",
    fill: "#04200f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcierge);
export default __webpack_public_path__ + "static/media/concierge.e27a430bb590fd53c21e8fcfedff56ca.svg";
export { ForwardRef as ReactComponent };